

export const basePath = '/schedule';
